const TEAMME_VIDEO_ID = "ebf623ec-3855-483f-a925-942b942b989d";
let loaded = false;
export function loadTeammeWidget(apiKey) {
    if (!apiKey || loaded) return;
    loaded = true;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://sdk.teamme.link/style.css";
    document.head.appendChild(link);
    const script = document.createElement("script");
    script.src = "https://sdk.teamme.link/widget.iife.js";
    script.onload = ()=>{
        if (window.teamme) {
            window.teamme.initialize({
                geo: [
                    "DE"
                ],
                apiKey,
                videoId: TEAMME_VIDEO_ID
            });
        }
    };
    document.head.appendChild(script);
}
